import React from "react";
import { useNavigate } from "react-router-dom";
import MatriculaFormFields from "./MatriculaFormFields";

const ModalWrapper = ({ open, title, children, onClose }) => {
  if (!open) return null;
  return (
    <div
      className="modal fade show d-block management-modal"
      tabIndex="-1"
      role="dialog"
      aria-modal="true"
      style={{ backgroundColor: "rgba(15, 23, 42, 0.45)" }}
    >
      <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header border-0">
            <h5 className="modal-title">{title}</h5>
            <button type="button" className="btn-close" aria-label="Cerrar" onClick={onClose} />
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default function MatriculaFormModal({
  modal,
  formNuevo,
  setFormNuevo,
  formEditar,
  setFormEditar,
  saving,
  deleting,
  editTab = "datos",
  matriculaEditando,
  cerrarModal,
  handleCrear,
  handleActualizar,
  handleEliminar,
  ciclosOptions = [],
  promocionesOptions = [],
  cursosOptions = [],
  loadingOptions = false,
  reloadOptions,
  ciclosOptionsMatriculaNueva,
  promocionesOptionsMatriculaNueva,
  incluirFinalizadas = false,
  toggleIncluirFinalizadas,
  loadingFinalizadas = false,
  estudianteNuevo,
  estudianteEditar,
  setDocumentoNuevo,
  buscarEstudianteNuevo,
  resultadosNuevo = [],
  seleccionarEstudiante,
  rolActual = "secretaria",
}) {
  const navigate = useNavigate();

  const renderCreateForm = (form, setForm, onSubmit, estudianteState) => {
    const handleSubmit = async (e) => {
      e.preventDefault();
      await onSubmit();
    };

    return (
      <form onSubmit={handleSubmit}>
        <div className="modal-body">
          <MatriculaFormFields
            form={form}
            setForm={setForm}
            isEdit={false}
            estudianteState={estudianteState}
            setDocumento={setDocumentoNuevo}
            buscarEstudiante={buscarEstudianteNuevo}
            resultados={resultadosNuevo}
            seleccionarEstudiante={seleccionarEstudiante}
            ciclosOptions={ciclosOptionsMatriculaNueva ?? ciclosOptions}
            promocionesOptions={promocionesOptionsMatriculaNueva ?? promocionesOptions}
            cursosOptions={cursosOptions}
            loadingOptions={loadingOptions}
            reloadOptions={reloadOptions}
            incluirFinalizadas={incluirFinalizadas}
            onToggleIncluirFinalizadas={toggleIncluirFinalizadas}
            loadingFinalizadas={loadingFinalizadas}
          />
        </div>
        <div className="modal-footer border-0">
          <button type="button" className="btn btn-outline-secondary" onClick={cerrarModal} disabled={saving}>
            Cancelar
          </button>
          <button type="submit" className="btn management-btn-primary" disabled={saving}>
            {saving ? "Guardando..." : "Guardar"}
          </button>
        </div>
      </form>
    );
  };

  const renderEditForm = () => {
    const handleSubmit = async (e) => {
      e.preventDefault();
      await handleActualizar({ closeOnSuccess: false });
      cerrarModal();
    };

    return (
      <form onSubmit={handleSubmit}>
        <div className="modal-body">
          <MatriculaFormFields
            form={formEditar}
            setForm={setFormEditar}
            isEdit={true}
            estudianteState={estudianteEditar}
            setDocumento={setDocumentoNuevo}
            buscarEstudiante={buscarEstudianteNuevo}
            resultados={[]}
            seleccionarEstudiante={seleccionarEstudiante}
            ciclosOptions={ciclosOptions}
            promocionesOptions={promocionesOptions}
            cursosOptions={cursosOptions}
            loadingOptions={loadingOptions}
            reloadOptions={reloadOptions}
            matriculaData={matriculaEditando}
          />
          {matriculaEditando?.estudianteId && (
            <div className="d-flex align-items-center gap-2 mt-3 p-2 rounded border bg-light">
              <i className="bi bi-box-seam text-primary fs-5" />
              <div className="flex-grow-1">
                <div className="small text-muted mb-0">Entregables de esta matricula</div>
                <button
                  type="button"
                  className="btn btn-link p-0 fw-semibold text-decoration-none"
                  onClick={() => {
                    cerrarModal();
                    navigate(
                      `/dashboard/estudiantes/${matriculaEditando.estudianteId}/detalle?tab=entregables&matriculaId=${matriculaEditando.id}`
                    );
                  }}
                >
                  Ver en la ficha del estudiante
                  <i className="bi bi-arrow-right ms-1" />
                </button>
              </div>
            </div>
          )}
        </div>
        <div className="modal-footer border-0">
          <button type="button" className="btn btn-outline-secondary" onClick={cerrarModal} disabled={saving}>
            Cancelar
          </button>
          <button type="submit" className="btn management-btn-primary" disabled={saving}>
            {saving ? "Guardando..." : "Guardar"}
          </button>
        </div>
      </form>
    );
  };

  return (
    <>
      <ModalWrapper open={modal === "crear"} title="Nueva matricula" onClose={cerrarModal}>
        {renderCreateForm(formNuevo, setFormNuevo, handleCrear, estudianteNuevo)}
      </ModalWrapper>

      <ModalWrapper open={modal === "editar"} title="Editar matricula" onClose={cerrarModal}>
        {renderEditForm()}
      </ModalWrapper>

      <ModalWrapper open={modal === "eliminar"} title="Eliminar matricula" onClose={cerrarModal}>
        <div className="modal-body">
          <p className="mb-1">Esta accion desactivara la matricula seleccionada.</p>
          <small className="text-muted">
            ID #{matriculaEditando?.id} | Estudiante #{matriculaEditando?.estudianteId}
          </small>
        </div>
        <div className="modal-footer border-0">
          <button type="button" className="btn btn-outline-secondary" onClick={cerrarModal} disabled={deleting}>
            Cancelar
          </button>
          <button type="button" className="btn btn-danger" onClick={handleEliminar} disabled={deleting}>
            {deleting ? "Eliminando..." : "Eliminar"}
          </button>
        </div>
      </ModalWrapper>
    </>
  );
}
